import { invokeHttp } from './api'

export const create = (booking) =>
  invokeHttp('admin/patient/reservation/booking/create', booking)

export const update = (booking) =>
  invokeHttp('admin/patient/reservation/booking/update', booking)

export const remove = (id) =>
  invokeHttp('admin/patient/reservation/booking/delete', { id })

export const prepareCreate = (reservationId) =>
  invokeHttp('admin/patient/reservation/booking/preparecreate', { reservationId })

export const prepareUpdate = (id) =>
  invokeHttp('admin/patient/reservation/booking/prepareupdate', { id })
